export const columns = [
    {
        name: "STT",
        field: "",
        headerStyle: {
            maxWidth: "40px",
            fontSize: "20px"
        },
        cellStyle: {
            textAlign: "center",
        },
        render: (rowData: any, index: number) => <span className="text-system fs-2">{rowData?.queueNumber ?? ""}</span>,
    },
    {
        name: "Mã bệnh nhân",
        field: "patientCode",
        headerStyle: {
            minWidth: "100px",
            fontSize: "20px"
        },
        render: (rowData: any, index: number) => <span className="text-system fs-2">{rowData?.patientCode ?? ""}</span>,
    },
    {
        name: "Tên bệnh nhân",
        field: "patientName",
        headerStyle: {
            minWidth: "175px",
            fontSize: "20px"
        },
        render: (rowData: any, index: number) => <span className="text-system fs-2">{rowData?.patientName ?? ""}</span>,
    }
];